import { formatLocalDateTime } from 'src/Utils/format'
import { Trans } from 'react-i18next'
import { YesOrNoDialog } from 'src/Components/YesOrNoDialog'

type OwnProps = {
  baneDataName: string
  currentReferenceCurveSwingDate: number | undefined
  currentReferenceCurveDate: number | undefined
  candidateReferenceCurveSwingTimestamp: number
  onAccept: () => void
  onReject: () => void
}

export const SwingSetReferenceCurveDialog = ({
  baneDataName,
  currentReferenceCurveSwingDate,
  currentReferenceCurveDate,
  candidateReferenceCurveSwingTimestamp,
  onAccept,
  onReject,
}: OwnProps) => (
  <YesOrNoDialog open onAccept={onAccept} onReject={onReject} onClose={onReject}>
    <Trans
      i18nKey="switches.setReferenceCurve.verificationQuestion"
      values={{ swingTimestamp: formatLocalDateTime(candidateReferenceCurveSwingTimestamp, false), baneDataName }}
    />{' '}
    {currentReferenceCurveDate && (
      <Trans
        i18nKey="switches.setReferenceCurve.currentSwingNotice"
        values={{
          date: formatLocalDateTime(currentReferenceCurveDate, true),
          swingDate: formatLocalDateTime(currentReferenceCurveSwingDate!, true),
        }}
      />
    )}
  </YesOrNoDialog>
)
